<!--
 * @Author: Hyman Choi
 * @Date: 2020-08-27 15:18:07
 * @LastEditTime: 2021-01-07 16:25:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.LiveWeb\src\components\AdManagementTable.vue
-->
<template>
  <div class="app-container">
    <div class="toolbar">
      <div class="left">
        <el-button :disabled="checkedList.length == 0" type="success" size="mini" icon="el-icon-check"
                   @click="startAD()">
          启用
        </el-button>
        <el-button :disabled="checkedList.length == 0" type="warning" size="mini" icon="el-icon-close"
                   @click="stopAD()">
          关闭
        </el-button>
        <el-button type="primary" size="mini" icon="el-icon-upload2" @click="showUploadADDlg()">
          上传
        </el-button>
        <el-button :disabled="checkedList.length == 0" type="danger" size="mini" icon="el-icon-delete"
                   @click="deleteAD()">
          删除
        </el-button>

        <el-select v-model="status" style="padding-left: 20px;" @change="curStatusChange">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="未启用" :value="0"></el-option>
        </el-select>
      </div>

      <div class="right">
        <el-button v-show="checkedList.length < adList.length" type="primary" size="mini" @click="selectAll()">
          全选
        </el-button>
        <el-button v-show="checkedList.length > 0" type="info" size="mini" @click="unchecked()">
          取消选择
        </el-button>

        <el-button type="primary" size="mini" @click="go2UploadTaskVC()">
          前往上传任务
        </el-button>
      </div>
    </div>

    <div class="list">
      <div :class="item.isChecked ? 'item item_active' : 'item'" v-for="(item, index) of adList" :key="index"
           @click="selected(item, index)">
        <video v-if="item.fileType == 0" controls controlslist="nodownload" @click.stop
               :poster="getImageUrl(item.advertisementCover)">
          <source :src="item.adPlayUrl" type="video/mp4"/>
          Sorry, your browser doesn't support embedded videos.
        </video>
        <el-image fit="scale-down" style="width: 94%;height: 100%" v-else-if="item.fileType ==  1"
                  :src="getImageUrl(item.adPlayUrl)"
                  :preview-src-list="getImageUrl(item.adPlayUrl)" @click.stop></el-image>
        <div style="width: 94%;" v-else-if="item.fileType == 2">
          <tx-video-player :video-url="item.adPlayUrl" :poster="getImageUrl(item.advertisementCover)"
                           preload="none"></tx-video-player>
        </div>
        <div class="bar">
					<span class="info ellipsis">
						{{ item.advertisementID }} | {{ item.adDescription }}
					</span>
          <div :class="item.status === 0 ? 'status_off' : 'status_on'">
            {{
              item.status === 0 ? '未启用' : '启用'
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="noData" v-if="adList.length === 0">
      暂无启用广告
    </div>

    <!-- 广告上传 -->
    <el-dialog title="广告上传" :visible.sync="showUploadDialog" width="50%" :close-on-click-modal="false">
      <div>
        <el-form :model="addADForm" label-width="70px">
          <el-form-item label="标题">
            <el-input v-model="addADForm.adDescription" placeholder="输入广告标题" maxlength="40"/>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="addADForm.fileType" @change="onFileTypeChange">
              <el-option v-for="item in adType" :value="item.type" :label="item.text" :key="item.type"></el-option>
            </el-select>
          </el-form-item>
          <!-- 视频 -->
          <div v-if="addADForm.fileType == 0">
            <el-form-item label="上传封面">
              <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                         :on-change="change2DisplayLocalImage" :auto-upload="false">
                <div style="text-align: left;">
                  <el-image style="width: 100px; height: 100px"
                            :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(addADForm.advertisementCover)"
                            fit="scale-down">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <br/>
                  <el-button size="small" type="primary">点击上传</el-button>
                </div>

                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-upload ref="uploadVideoRef" accept=".mp4" action="" class="upload-demo" :auto-upload="false"
                         :on-change="uploadVideoChange" :limit="1">
                <div style="text-align: left;">
                  <video id="upvideo" v-if="uploadVideoFile !== null"
                         :src="uploadVideoFile !== null ? uploadVideoFileURL : getImageUrl(addADForm.adPlayUrl)"
                         controls style="width: 100%;height: 30vh;overflow: auto;"/>
                  <br/>
                  <el-button size="small" type="primary">点击上传</el-button>
                </div>

                <div slot="tip" class="el-upload__tip">
                  只能上传mp4文件
                </div>
              </el-upload>
            </el-form-item>
          </div>
          <!--  图片 -->
          <div v-if="addADForm.fileType == 1">
            <el-form-item label="上传图片">
              <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                         :on-change="change2DisplayLocalImage" :auto-upload="false">
                <div style="text-align: left;">
                  <el-image style="width: 100px; height: 100px"
                            :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(addADForm.adPlayUrl)"
                            fit="scale-down">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <br/>
                  <el-button size="small" type="primary">点击上传</el-button>
                </div>

                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件
                </div>
              </el-upload>
            </el-form-item>
          </div>
          <!-- 直播 -->
          <div v-if="addADForm.fileType == 2">
            <el-form-item label="拉流地址">
              <el-input v-model="addADForm.adPlayUrl" placeholder="输入拉流地址"/>
              <!-- 平台内直播可以直接去直播看，这个功能存在意义不大 -->
              <el-button type="primary" size="small" @click="openSearchLiveDlg()">从平台内直播中复制</el-button>
              <el-button type="primary" size="small" @click="showRtmpPlayerDlg = true">预览</el-button>
            </el-form-item>
            <el-form-item label="上传图片">
              <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                         :on-change="change2DisplayLocalImage" :auto-upload="false">
                <div style="text-align: left;">
                  <el-image style="width: 100px; height: 100px"
                            :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(addADForm.adPlayUrl)"
                            fit="scale-down">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <br/>
                  <el-button size="small" type="primary">点击上传</el-button>
                </div>

                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="showUploadDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="uploadAD()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showRtmpPlayerDlg" :destroy-on-close="true">
      <tx-video-player style="height: 60vh" :video-url="addADForm.adPlayUrl"></tx-video-player>
    </el-dialog>

    <el-dialog :visible.sync="showLiveListDlg" :destroy-on-close="true" :close-on-click-modal="false">
      <div class="topbar">
        <el-input v-model="searchLiveValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.native.enter="searchLive()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" @click.stop="searchLive()">
          搜索
        </el-button>
      </div>
      <el-table
          border
          v-loading="searchLiveLoading"
          :data="liveList"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px;height: 60vh;overflow: auto"
      >
        <el-table-column prop="liveID" label="ID" width="100" align="center"></el-table-column>
        <el-table-column label="状态" width="100" prop="liveState" align="center">
          <template #default="scrop">
            {{ scrop.row.liveState | liveStateTransform }}
          </template>
        </el-table-column>
        <el-table-column prop="liveTitle" label="标题" align="center"></el-table-column>
        <el-table-column prop="liveTitle" label="主播信息" width="150" align="center">
          <template #default="scope">
            <user-info :user="scope.row"></user-info>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template #default="scope">
            <el-button type="text" size="small" @click="copyLiveURL(scope.row,'rtmp')">复制RTMP地址</el-button>
            <el-button type="text" size="small" @click="copyLiveURL(scope.row,'hlc')">复制HLC地址</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <canvas id="mycanvas" style="display: none"></canvas>
  </div>
</template>

<script>
import {
  getAdvertisementList,
  startAdvertisement,
  stopAdvertisement,
  deleteAdvertisement,
  addAdvertisement
} from '@/api/mai/liveManagement/ADManagement'
import {
  handleRes
} from "@/utils/handleRes"
import {
  printObj
} from "@/utils/debug"
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {isVaild} from "@/utils/validate";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";
import {addTask} from "@/utils/uploadManager";
import {Message} from "element-ui";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import {getLiveList} from "@/api/mai/liveManagement/liveManagement";
import UserInfo from "@/components/UserInfo/UserInfo";
import {copy2Clipboard} from "@/utils/clipboard";

export default {
  components: {UserInfo, TxVideoPlayer},
  data() {
    return {
      adList: [], // 广告列表
      checkedList: [], // 选中列表
      showUploadDialog: false, // 是否显示上传对话框
      addADForm: {}, // 新增广告数据表单
      //0-视频 1-图片 2-直播 默认0
      adType: [
        {type: 0, text: "视频"},
        {type: 1, text: "图片"},
        {type: 2, text: "直播"},
      ],
      uploadVideoFile: null,//选择的上传视频文件
      uploadVideoFileURL: "",//选择上传文件后转换成的本地url，用于播放预览
      uploadCoverFile: null,//选择的上传视频封面
      uploadCoverFileURL: "",//选择上传文件后转换成的本地url，用于播放预览
      uploadCoverFromVideo: "",//截取的视频封面

      showRtmpPlayerDlg: false,//预览，根据地址播放看地址是否正确，辅助作用，网页端rtmp不了，hls有部分也播不了

      //搜索直播相关
      showLiveListDlg: false,
      searchLiveValue: "",
      liveList: [],
      searchLiveLoading: false,

      status: -1, // 使用状态
    }
  },
  created() {
    this.getAdvertisementList()
  },
  methods: {
    curStatusChange() {
      this.getAdvertisementList()
    },
    /**
     * 获取广告列表
     */
    getAdvertisementList() {
      let params = {
        status: this.status, // 使用状态 -1-获取全部, 0-未启用, 1-已启用
        deleteType: 0 // 删除状态 -1-获取全部, 0-未删除, 1-已删除
      }
      getAdvertisementList(params).then(res => {
        this.adList = res.data
      })
    },
    /**
     * 清除新增广告对话框已选择文件的内容，包括视频、图片和转换的本地预览地址
     */
    clearSelectedFiles() {
      try {

        this.uploadCoverFile = null
        this.uploadCoverFileURL = null
        this.uploadVideoFile = null
        this.uploadVideoFileURL = null
        this.$refs.uploadCoverRef.clearFiles();
        this.$refs.uploadVideoRef.clearFiles()
      } catch (e) {

      }
    },
    /**
     * 上传广告
     */
    showUploadADDlg() {
      this.addADForm = {
        fileType: 0
      }
      this.clearSelectedFiles();
      this.showUploadDialog = true
    },
    /**
     * 启用广告
     */
    startAD: _.throttle(
        function () {
          let _this = this
          let isBlock = false // 逻辑判断
          let data = {
            iDList: _this.checkedList.toString()
          }

          // 选中广告是否已开启
          _this.adList.map(x => {
            _this.checkedList.map(y => {
              if (y == x.advertisementID && x.status) {
                isBlock = true
              }
            })
          })

          if (isBlock) {
            _this.$message.error('操作失败，广告已启用!')
          } else {
            _this.$message('请等待...')
            startAdvertisement(data)
                .then(res => {
                  handleRes(res, () => {
                    _this.unchecked()
                    _this.getAdvertisementList()
                    _this.$message({
                      message: '操作成功!',
                      type: 'success'
                    })
                  })

                })
                .catch(err => {
                  console.log(err)
                  _this.unchecked()
                  _this.getAdvertisementList()
                })
          }
        },
        3000, {
          trailing: false
        }
    ),
    /**
     * 关闭广告
     */
    stopAD: _.throttle(
        function () {
          let _this = this
          let isBlock = false // 逻辑判断
          let data = {
            iDList: _this.checkedList.toString()
          }

          // 选中广告是否已关闭
          _this.adList.map(x => {
            _this.checkedList.map(y => {
              if (y == x.advertisementID && !x.status) {
                isBlock = true
              }
            })
          })

          if (isBlock) {
            _this.$message.error('操作失败，广告未启用!')
          } else {
            _this.$message('请等待...')
            stopAdvertisement(data).then(res => {
              handleRes(res, () => {
                _this.unchecked()
                _this.getAdvertisementList()
                _this.$message({
                  message: '操作成功!',
                  type: 'success'
                })
              })

            })
          }
        },
        3000, {
          trailing: false
        }
    ),
    /**
     * 删除广告
     */
    deleteAD: _.throttle(
        function () {
          let _this = this
          let isBlock = false // 逻辑判断
          let data = {
            iDList: _this.checkedList.toString()
          }

          // 选中广告是否已开启
          _this.adList.map(x => {
            _this.checkedList.map(y => {
              if (y == x.advertisementID && x.status) {
                isBlock = true
              }
            })
          })

          if (isBlock) {
            _this.$message.error('请先关闭广告!')
          } else {
            _this
                .$confirm('是否删除所选广告?', '提示', {
                  confirmButtonText: '是',
                  cancelButtonText: '否',
                  type: 'warning'
                })
                .then(res => {
                  deleteAdvertisement(data).then(res => {
                    _this.unchecked()
                    _this.getAdvertisementList()
                    _this.$message({
                      message: '操作成功!',
                      type: 'success'
                    })
                  })
                })
          }
        },
        3000, {
          trailing: false
        }
    ),
    /**
     * 取消选中
     */
    unchecked() {
      this.checkedList = []
      this.adList.map(item => {
        item.isChecked = false
      })
    },
    /**
     * 选中
     *
     * @param item
     * @param index
     */
    selected(item, index) {
      let isSelected = false
      // 判断是否已选中
      this.checkedList.map(x => {
        if (x === item.advertisementID) isSelected = true
      })
      // 更变选择状态
      if (isSelected) {
        this.checkedList = this._.without(
            this.checkedList,
            item.advertisementID
        )
      } else {
        this.checkedList.push(item.advertisementID)
      }
      // 更变选择样式
      this.adList[index].isChecked = isSelected ? false : true
    },
    /**
     * 全选
     */
    selectAll() {
      this.adList.map(x => {
        x.isChecked = true
        this.checkedList.push(x.advertisementID)
      })
      // 去重
      this.checkedList = this._.uniq(this.checkedList)
    },
    /**
     * 打开搜索直播对话框
     */
    openSearchLiveDlg() {
      this.liveList = []
      this.searchLiveLoading = false;
      this.showLiveListDlg = true;
    },
    /**
     * 搜索直播对话框中，搜索按钮响应事件
     */
    searchLive() {
      if (!isVaild(this.searchLiveValue)) {
        return
      }
      this.searchLiveLoading = true;
      const params = {
        keyWord: this.searchLiveValue,
      };

      getLiveList(params).then((res) => {
        handleRes(res, () => {
          this.liveList = res.data.list;
        })

        this.searchLiveLoading = false;
      });
    },
    /**
     * 回填新增广告的拉流地址
     * @param entity
     * @param type
     */
    copyLiveURL(entity, type) {
      let content = ""
      if (type == "rtmp") {
        content = entity.pushFlowURL
      } else if (type == 'hlc') {
        content = entity.hlsUrl
      }
      copy2Clipboard(content)
      this.addADForm.adPlayUrl = content
      this.showLiveListDlg = false;
    },
    /**
     * url处理，会加上oss头
     * @param url
     * @returns {string|*}
     */
    getImageUrl(url) {
      return getCloudUrl(url)
    },
    /**
     * 广告类型切换，监听事件
     */
    onFileTypeChange() {
      this.$forceUpdate()
      this.clearSelectedFiles()
    },
    /**
     * 选中的图片文件转换成预览url
     * @param uploadFile
     */
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    /**
     * 选中的视频文件转换成预览URL，并截取封面
     * @param uploadFile
     * @returns {Promise<void>}
     */
    async uploadVideoChange(uploadFile) {
      if (this.addADForm.fileType == 0) {//视频
        this.$refs.uploadVideoRef.clearFiles()
        this.uploadVideoFile = uploadFile
        this.uploadVideoFileURL = getLocalFileURL(uploadFile)
        let duration = await this.getVideoDuration(this.uploadVideoFileURL);
        // this.uploadVideoTimeLength = duration / 1000;
        this.getVideoCover(this.uploadVideoFileURL)
      }
    },
    /**
     * 通过canvas截取视频封面
     * @param url
     */
    getVideoCover(url) {
      const video = document.getElementById("upvideo"); // 获取视频对象
      // const video = document.createElement("video") // 也可以自己创建video
      // console.log('----- getVideoCover ' + video)
      video.src = url; // url地址 url跟 视频流是一样的
      var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth; // 获取视频宽度
        canvas.height = video.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        // 转换成base64形式
        this.imgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
        this.uploadCoverFromVideo = this.imgsrc;
        // console.log(this.uploadCoverFromVideo)
      };
    },
    /**
     * 获取视频时长
     * @param url
     * @returns {Promise<unknown>}
     */
    getVideoDuration(url) {

      return new Promise((resolve) => {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.onloadedmetadata = () => {
          resolve(parseInt((video.duration * 1000).toString(), 10));
          video = null;
        };
      });
    },
    /**
     * 上传广告逻辑
     * @returns {Promise<void>}
     */
    async uploadAD() {

      let ossSavePathParamsRes = await getOSSUploadInfo({
        DataType: "35",
        ID: "0",
      });
      if (!isVaild(ossSavePathParamsRes)) {
        Message({
          message: "获取oss信息出错",
          type: 'error'
        })
        return;
      }

      if (this.addADForm.fileType == 0) {//视频
        if (!isVaild(this.uploadVideoFile)) {
          this.$message.warning("请选择视频")
          return
        }

        //上传封面
        let savePathParams = ossSavePathParamsRes.resultData
        if (isVaild(this.uploadCoverFile) || isVaild(this.uploadCoverFromVideo)) {
          let timestamp = new Date().valueOf();

          let uploadRes;
          let fileName;

          if (isVaild(this.uploadCoverFile)) {//上传用户自己选取封面
            fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
            // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
            uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
              type: this.uploadCoverFile.raw.type
            }), fileName)
          } else if (isVaild(this.uploadCoverFromVideo)) {//用户没有选取封面，上传自动截图的封面
            let data = this.uploadCoverFromVideo
            var str = data.split(",");
            var suffix = data.split(";")[0].split("/")[1];
            // console.log("IMG-Suffix====>>", suffix)
            fileName = savePathParams.PicSavePath + "cover_from_video_" +
                timestamp + "." + suffix;
            // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)

            //base64
            var buffer = Buffer.from(str[1], 'base64');
            uploadRes = await uploadFile2OSS(savePathParams, buffer, fileName)
          }
          if (uploadRes.status === 0) {
            this.addADForm.advertisementCover = "/" + fileName
            // console.log(this.form.liveCover)
          } else {
            this.$message({
              type: "error",
              message: "上传失败"
            })
          }
        }
        let data = deepClone(this.addADForm)
        //上传视频
        if (isVaild(this.uploadVideoFile)) {
          //视频比较大，后台上传
          this.showUploadDialog = false;
          let timestamp = new Date().valueOf();
          const fileName = savePathParams.PicSavePath + timestamp + this.uploadVideoFile.name.substring(this.uploadVideoFile.name.lastIndexOf("."));
          // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)

          let uploadRes = await addTask({
            from: "直播广告",
            ossInfo: savePathParams,
            file: new Blob([this
                .uploadVideoFile.raw
            ], {
              type: this.uploadVideoFile.raw.type
            }),
            filePath: fileName,
            orgName: this.uploadVideoFile.name,
            finishCallback: async (uploadInfo) => {
              data.adPlayUrl = this.config.RESOURCES + "/" + fileName
              let res = await addAdvertisement(data);
              if (res.code === 200) {
                uploadInfo.status = 3
              } else {
                uploadInfo.status = 2
                uploadInfo.remarks = res.message
              }
            }
          }, (status) => {
            if (status.status === 0) {

              this.editReviewDialog = false;
              this.$message.success("已添加到上传任务")
            } else {
              this.$message.warning(status.msg)
            }
          })

        }
      } else if (this.addADForm.fileType == 1 || this.addADForm.fileType == 2) {//图片、直播
        if (!isVaild(this.uploadCoverFile)) {
          this.$message.warning("请选择图片")
          return
        }

        if (this.addADForm.fileType == 2 && !isVaild(this.addADForm.adPlayUrl)) {
          this.$message.warning("请填写推流地址")
          return
        }

        //上传图片
        let savePathParams = ossSavePathParamsRes.resultData
        if (isVaild(this.uploadCoverFileURL)) {
          let timestamp = new Date().valueOf();

          let uploadRes;
          let fileName;

          fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
          // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
          uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
            type: this.uploadCoverFile.raw.type
          }), fileName)
          if (uploadRes.status === 0) {
            if (this.addADForm.fileType == 1) {
              this.addADForm.adPlayUrl = this.config.RESOURCES + "/" + fileName
            } else {
              this.addADForm.advertisementCover = "/" + fileName
            }

            // console.log(this.form.liveCover)

            let res = await addAdvertisement(deepClone(this.addADForm));
            handleRes(res, () => {
              this.showUploadDialog = false;
              this.$message("添加成功")
              this.getAdvertisementList()
            })
          } else {
            this.$message({
              type: "error",
              message: "上传失败"
            })
          }

        }
      }
    },
    /**
     * 跳转到上传任务界面
     */
    go2UploadTaskVC() {
      this.$router.push({
        name: "uploadManage",
      })
    }
  }
}
</script>

<style scoped lang="scss">
.toolbar {
  display: flex;
  justify-content: space-between;
}

.list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 20px;

  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 19%;
    margin-right: 1.25%;
    margin-bottom: 20px;
    box-sizing: border-box;
    border: 1px solid #e2e9ff;
    background-color: #f9fcff;
    border-radius: 4px;

    video {
      width: 94%;
      margin-top: 3%;
    }

    .bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50px;

      .info {
        margin-left: 12px;
        font-size: 15px;
        width: 200px;
        text-align: left;
      }

      .status_on,
      .status_off {
        display: flex;
        align-items: center;
        margin-right: 9px;
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 2px;
        background-color: #67c23a;
        color: #ffffff;
      }

      .status_off {
        background-color: #f56c6c;
      }
    }
  }

  .item:nth-of-type(5) {
    margin-right: 0;
  }

  .item:hover {
    cursor: pointer;
    background-color: rgba($color: #409eff, $alpha: 0.8);

    .info {
      color: #ffffff;
    }
  }

  .item_active {
    background-color: #409eff;

    .info {
      color: #ffffff;
    }
  }
}

.el-upload__tip {
  display: inline-flex;
  margin: 0 0 0 20px;
}

.noData {
  height: 400px;
  line-height: 400px;
  border: 1px solid #e2e9ff;
  background-color: #f9fcff;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/AdManagementTable.vue
